import React, { FC, useState } from 'react';

import { SlackBotService } from 'api/services';
import { OutlinedIconButton } from 'components/DataEntry';
import { SlackIcon } from 'components/Icons';
import { infoToast } from 'components/Toast/toasterFunctions';

interface Props {
  label?: string;
}

// Starts the Slack install: asks the bot for the authorize URL (authenticated),
// then sends the browser to Slack. Slack redirects back to /jit/setup.
export const ConnectSlackButton: FC<Props> = ({ label = 'Connect Slack' }) => {
  const [loading, setLoading] = useState(false);

  const handleConnect = async () => {
    setLoading(true);
    try {
      const res = await SlackBotService.Commands.startSlackInstall();
      const authorizeUrl = res?.data?.authorize_url;
      if (authorizeUrl) {
        window.location.href = authorizeUrl;
        return;
      }
      throw new Error('Missing authorize_url');
    } catch {
      setLoading(false);
      infoToast({
        title: 'Could not start Slack install',
        description: 'Please try again.',
      });
    }
  };

  return (
    <OutlinedIconButton
      leftIcon={<SlackIcon />}
      isLoading={loading}
      onClick={handleConnect}
    >
      {label}
    </OutlinedIconButton>
  );
};
